import React, { useState, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  NavLink,
} from "react-router-dom";
// import * as Realm from "realm-web";
import {
  Nav,
  Navbar,
  Container,
  Row,
  Col,
  Jumbotron,
  Form,
} from "react-bootstrap";
import Metingen from "./components/Metingen";
import BeitsTijden from "./components/BeitsTijden";
import "bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import ReactCodeInput from "react-code-input";

function App() {
  const [pin, setPin] = useState();

  useEffect(() => {
    const p = localStorage.getItem("pin");
    if (p) setPin(p);
  }, []);

  useEffect(() => {
    try {
    } catch {
      alert("Failed to log in");
      localStorage.setItem("pin", "");
      setPin();
    }
  }, [pin]);

  if (!pin || pin !== "2323")
    return (
      <Jumbotron
        style={{ textAlign: "center", width: "20rem" }}
        className="mx-auto"
      >
        <img
          src="/EloxL.svg"
          width="150"
          height="150"
          className="d-inline-block align-top"
          alt="Elox"
        />
        <h5>Voer aub uw PIN in:</h5>
        <Form autoComplete="off">
          <ReactCodeInput
            type="password"
            fields={4}
            value={pin}
            autoComplete="off"
            onChange={(e) => setPin(e)}
          />
        </Form>
      </Jumbotron>
    );

  return (
    <Router>
      <Navbar bg="dark" variant="dark" expand="lg" collapseOnSelect>
        <Navbar.Brand href="/">
          <img
            src="/EloxL.svg"
            width="100"
            height="30"
            className="d-inline-block align-top"
            alt="Elox"
          />
          Beits
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" id="navtoggle" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="mr-auto">
            <Nav.Item>
              <NavLink
                to="/metingen"
                onClick={() => document.querySelector("#navtoggle").click()}
                className="nav-link"
              >
                Metingen
              </NavLink>
            </Nav.Item>
            <Nav.Item>
              <NavLink
                to="/beitstijden"
                onClick={() => document.querySelector("#navtoggle").click()}
                className="nav-link"
              >
                Beitstijden
              </NavLink>
            </Nav.Item>
          </Nav>
        </Navbar.Collapse>
      </Navbar>
      <Container className="App">
        <Row>
          <Col lg={6}>
            <Switch>
              <Route path="/metingen">
                <Metingen />
              </Route>
              <Route path="/beitstijden">
                <BeitsTijden />
              </Route>
              <Route path="/">
                <Jumbotron style={{ textAlign: "center" }}>
                  <img
                    src="/EloxL.svg"
                    width="150"
                    height="150"
                    className="d-inline-block align-top"
                    alt="Elox"
                  />
                  <h1>Welkom</h1>
                </Jumbotron>
              </Route>
            </Switch>
          </Col>
        </Row>
      </Container>
    </Router>
  );
}

export default App;
